// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"80b32b9a","977":"a7ee2397"}[chunkId] + ".chunk.js";
};